export const schema = {
  type: 'object',
  properties: {
    date_start: {
      title: 'Дата начала',
      type: 'string',
      format: 'date',
      options: {
        isDisabledDatePrev: false,
      },
    },
    date_end: {
      title: 'Дата окончания',
      type: 'string',
      format: 'date',
      options: {
        isDisabledDatePrev: false,
      },
    },
    vacancy_id: {
      type: 'string',
      title: 'Вакансия',
      view: {
        name: 'select-from-enum',
      },
      options: {
        showSearch: true,
      },
    },
    department_id: {
      type: 'string',
      title: 'Отдел',
      view: {
        name: 'select-from-enum',
      },
      options: {
        showSearch: true,
      },
    },
    quantity: {
      type: 'number',
      title: 'Кол-во вакансий',
    },
  },
  required: ['date_start', 'date_end', 'vacancy_id', 'department_id', 'quantity'],
}
